import { call, put, select, takeEvery } from "redux-saga/effects";
import { LOCATION_CHANGE } from "redux-first-history";
import isEmpty from "lodash/isEmpty";

import {
  GET_APP_INFO,
  GET_APP_INFO_FAILURE,
  GET_APP_INFO_SUCCESS
} from "./appInfo.action";

import { appInfoRequest } from "./appInfo.api";
import {appInfoStore} from "@/store/newStores";

function* getAppInfoOnLocationChangeData() {
  try {
    const appInfo = yield select(state => state.appInfo);
    if (isEmpty(appInfo)) yield put({ type: GET_APP_INFO });
  } catch (error) {
    console.log(error);
  }
}

const updateNewStores = (data) => {
  appInfoStore.churches.set(data.churches.reduce((acc, church) => {
    acc[church.id] = church;
    return acc;
  }, {}));
  appInfoStore.emirates.set(data.emirates.reduce((acc, emirate) => {
    acc[emirate.id] = emirate;
    return acc;
  }, {}));
  appInfoStore.countries.set(data.countries.reduce((acc, country) => {
    acc[country.id] = country;
    return acc;
  }, {}));
  appInfoStore.fathers.set(data.fathers.reduce((acc, father) => {
    acc[father.id] = father;
    return acc;
  }, {}));
  appInfoStore.workingFields.set(data.workingFields.reduce((acc, workingField) => {
    acc[workingField.id] = workingField;
    return acc;
  }, {}));
};

function* fetchAppInfo() {
  try {
    const { response } = yield call(appInfoRequest);

    updateNewStores(response.data);
    if (response.status === 200) {
      yield put({
        type: GET_APP_INFO_SUCCESS,
        payload: response.data
      });
    } else {
      yield put({
        type: GET_APP_INFO_FAILURE
      });
    }
  } catch (error) {
    yield put({ type: GET_APP_INFO_FAILURE });
    console.log(error);
  }
}

export default function* appInfoSaga() {
  yield takeEvery(LOCATION_CHANGE, getAppInfoOnLocationChangeData);
  yield takeEvery(GET_APP_INFO, fetchAppInfo);
}
